import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 0,
  style: {
    "padding": "15px 0px 0px 5px",
    "color": "#adadad"
  }
};
const _hoisted_2 = {
  class: "assets-wrap"
};
const _hoisted_3 = {
  key: 1,
  style: {
    "width": "100%",
    "height": "120px",
    "position": "relative"
  }
};
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 3,
  class: "sms-con"
};
const _hoisted_7 = {
  key: 4,
  class: "other-image"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  style: {
    "padding": "6px 0px"
  }
};
const _hoisted_10 = {
  class: "item-title"
};
const _hoisted_11 = {
  class: "bottom"
};
const _hoisted_12 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SuccessFilled = _resolveComponent("SuccessFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_card = _resolveComponent("el-card");
  const _component_select_favorite = _resolveComponent("select-favorite");
  return _openBlock(), _createElementBlock(_Fragment, null, [$props.assetsList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, " 没有检索到任何数据 ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.assetsList, i => {
    return _openBlock(), _createBlock(_component_el_card, {
      "body-style": {
        padding: '0px'
      },
      style: {
        "width": "210px",
        "cursor": "pointer"
      },
      key: i.id,
      onClick: $event => $setup.showDetail(i),
      class: "el-card-vue"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, {
        class: _normalizeClass([{
          'checking': !i.check,
          'checked': i.check
        }, "check-icon"]),
        onClick: _withModifiers($event => $setup.selectChange(i), ["stop"])
      }, {
        default: _withCtx(() => [_createVNode(_component_SuccessFilled)]),
        _: 1
      }, 8, ["class", "onClick"]), i.srcTyp === '1' ? (_openBlock(), _createBlock(_component_el_image, {
        key: 0,
        style: {
          "width": "100%",
          "height": "120px"
        },
        fit: "scale-down",
        src: i.srcOutUrl ? i.srcOutUrl : i.srcInnUrl + '_s',
        lazy: ""
      }, null, 8, ["src"])) : _createCommentVNode("", true), i.srcTyp === '2' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("audio", {
        style: {
          "width": "100%",
          "height": "120px",
          "position": "absolute",
          "bottom": "20%"
        },
        src: i.srcOutUrl ? i.srcOutUrl : i.srcInnUrl,
        controls: "controls"
      }, null, 8, _hoisted_4)])) : _createCommentVNode("", true), i.srcTyp === '3' ? (_openBlock(), _createElementBlock("video", {
        key: 2,
        width: "210",
        height: "120",
        src: i.srcOutUrl ? i.srcOutUrl : i.srcInnUrl,
        muted: "",
        controls: "controls"
      }, " 您的浏览器不支持 HTML5 video 标签。 ", 8, _hoisted_5)) : _createCommentVNode("", true), i.srcTyp === '7' ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(i.content), 1)) : _createCommentVNode("", true), i.srcTyp !== '1' && i.srcTyp !== '2' && i.srcTyp !== '3' && i.srcTyp !== '7' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
        style: {
          "width": "120px",
          "height": "120px"
        },
        src: $setup.srcType[i.srcTyp] && $setup.srcType[i.srcTyp].src ? $setup.srcType[i.srcTyp].src : $setup.srcType[6].src
      }, null, 8, _hoisted_8)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(i.assetsName), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createElementVNode("span", null, "入库时间：" + _toDisplayString(i.createTime), 1), _createElementVNode("span", null, "生效时间：" + _toDisplayString(i.bgnDate), 1), _createElementVNode("span", null, "失效时间：" + _toDisplayString(i.endDate), 1)]), _createElementVNode("i", {
        class: _normalizeClass([{
          'el-icon-star-on': i.favorite == true,
          'el-icon-star-off': i.favorite == false
        }, "coll"]),
        onClick: _withModifiers($event => $setup.favHandler(i), ["stop"])
      }, null, 10, _hoisted_12)])])]),
      _: 2
    }, 1032, ["onClick"]);
  }), 128)), _createVNode(_component_select_favorite, {
    ref: "selectFavoriteRef",
    choseAsset: _ctx.choseAsset,
    onOk: $setup.favorited
  }, null, 8, ["choseAsset", "onOk"])])], 64);
}